/* eslint-disable no-unused-expressions, no-magic-numbers */

class BedragIneensTable {

    /**
     * @param {HTMLElement} element
     * @param {Object} options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._elements = {
            window: this._element.querySelector('.bedrag-ineens-table__tablist'),
            cards: [...this._element.querySelectorAll('[role="tabpanel"]')],
            tabs: [...this._element.querySelectorAll('[role="tab"]')],
            columns: [...this._element.querySelectorAll('.bedrag-ineens-table__column')],
            notifications: [...this._element.querySelectorAll('.bedrag-ineens-table__notification')]
        };

        this._state = {
            currentTab: 0,
            isMobile: false,
            mobileWidth: 768,
            currentCategory: 'beforeAowAge'
        };

        this._elements.tabs.forEach(tab => {
            tab.setAttribute('aria-selected', true);
        });

        this._elements.cards.forEach(card => {
            card.setAttribute('aria-hidden', false);
        });

        this._elements.notifications.forEach(notification => {
            notification.setAttribute('aria-hidden', false);
        });
    }
}

// Exports
export default BedragIneensTable;
/* eslint-enable */
